export default "__VITE_ASSET__7612f232__"